import { normalizeAnalysisConfig } from './analysisConfig';

export const creativeKinds = ['product_feature', 'offer', 'setting'] as const;
export type CreativeKind = typeof creativeKinds[number];
export type MarketCreativeConfig = { schema_version: 'market-creative-config/v1'; enabled: false }
    | { schema_version: 'market-creative-config/v1'; enabled: true; creative_kinds: CreativeKind[]; report_language: string;
        max_records: number; max_model_calls: number; estimated_work_units_limit: string };

/** Mirrors the independent Platform contract. Absence is legacy; null is never a reset. */
export function normalizeCreativeConfig(value: unknown): MarketCreativeConfig {
    const invalid = () => new Error('Invalid creative analysis configuration');
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw invalid();
    const input = value as Record<string, unknown>;
    if (input.schema_version !== 'market-creative-config/v1' || typeof input.enabled !== 'boolean') throw invalid();
    if (!input.enabled) {
        if (Object.keys(input).length !== 2) throw invalid();
        return { schema_version: 'market-creative-config/v1', enabled: false };
    }
    if (Object.keys(input).length !== 7 || !Array.isArray(input.creative_kinds) || !input.creative_kinds.length
        || input.creative_kinds.length > 3 || !input.creative_kinds.every(kind => creativeKinds.includes(kind))
        || new Set(input.creative_kinds).size !== input.creative_kinds.length
        || typeof input.report_language !== 'string' || input.report_language.length > 35
        || !/^[A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/.test(input.report_language)) throw invalid();
    const limits = normalizeAnalysisConfig({ schema_version: 'market-analysis-config/v1', enabled: true,
        max_records: input.max_records, max_model_calls: input.max_model_calls, estimated_work_units_limit: input.estimated_work_units_limit });
    if (!limits.enabled || limits.max_records > 100) throw invalid();
    return { ...limits, schema_version: 'market-creative-config/v1', creative_kinds: [...input.creative_kinds], report_language: input.report_language };
}
export function validCreativeConfig(value: unknown): boolean {
    if (value === undefined) return true;
    try { normalizeCreativeConfig(value); return true; } catch { return false; }
}
export function creativeConfigMatches(requested: unknown, echoed: unknown): boolean {
    if (requested === undefined) return true;
    try { return JSON.stringify(normalizeCreativeConfig(requested)) === JSON.stringify(normalizeCreativeConfig(echoed)); }
    catch { return false; }
}
